module.exports = __webpack_public_path__ + "img/011曲明.6bbf69ff.png";